import React from 'react';

export default function OptionButton({ label, emoji, selected, onTap }) {
  return (
    <button
      onClick={onTap}
      style={{
        fontFamily: "'Fredoka One', cursive",
        fontSize: 'clamp(1rem, 2.5vw, 1.4rem)',
        background: selected ? '#FFD600' : 'white',
        color: '#111',
        border: '4px solid #111',
        borderRadius: 50,
        padding: '10px 20px',
        cursor: 'pointer',
        boxShadow: selected ? '2px 2px 0 #111' : '5px 5px 0 #111',
        transform: selected ? 'translate(3px, 3px)' : 'none',
        transition: 'background 0.15s, transform 0.1s, box-shadow 0.1s',
        minWidth: 160,
        flex: '1 1 140px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
      }}
    >
      {emoji && <span style={{ fontSize: '1.8rem', lineHeight: 1 }}>{emoji}</span>}
      {label}
    </button>
  );
}
